export const videoStatus = [
    {
        id: 1,
        status: 'waiting',
        label: 'Chưa hoàn thành',
        color: 'blue',
    },
    {
        id: 2,
        status: 'completed',
        label: 'Đã hoàn thành',
        color: 'green',
    },
    {
        id: 3,
        status: 'failed',
        label: 'Lỗi xử lý video',
        color: 'red',
    },
    {
        id: 4,
        status: 'downloaded',
        label: 'Video đã tải',
        color: 'purple',
    },
    {
        id: 5,
        status: 'not_downloaded',
        label: 'Video chưa tải',
        color: 'orange',
    },
];
